/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonthSettleVo } from './MonthSettleVo';
import {
    MonthSettleVoFromJSON,
    MonthSettleVoFromJSONTyped,
    MonthSettleVoToJSON,
    MonthSettleVoToJSONTyped,
} from './MonthSettleVo';

/**
 * 
 * @export
 * @interface CommissionSettlePageItemVo
 */
export interface CommissionSettlePageItemVo {
    /**
     * 会员id
     * @type {number}
     * @memberof CommissionSettlePageItemVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    userName?: string;
    /**
     * 会员手机号
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    mobileNo?: string;
    /**
     * 佣金收款银行卡ID（business_type=1的有效卡，无则为null）
     * @type {number}
     * @memberof CommissionSettlePageItemVo
     */
    bankCardId?: number;
    /**
     * 佣金收款银行卡号
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    bankCardNumber?: string;
    /**
     * 佣金收款银行名
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    bankName?: string;
    /**
     * 佣金收款持卡人姓名
     * @type {string}
     * @memberof CommissionSettlePageItemVo
     */
    bankCardHolderName?: string;
    /**
     * 佣金收款卡类型 1储蓄卡 2信用卡
     * @type {number}
     * @memberof CommissionSettlePageItemVo
     */
    bankCardType?: number;
    /**
     * 各月份聚合数据（仅包含有佣金记录的月份，未包含的月份前端显示"-"）
     * @type {Array<MonthSettleVo>}
     * @memberof CommissionSettlePageItemVo
     */
    months?: Array<MonthSettleVo>;
}

/**
 * Check if a given object implements the CommissionSettlePageItemVo interface.
 */
export function instanceOfCommissionSettlePageItemVo(value: object): value is CommissionSettlePageItemVo {
    return true;
}

export function CommissionSettlePageItemVoFromJSON(json: any): CommissionSettlePageItemVo {
    return CommissionSettlePageItemVoFromJSONTyped(json, false);
}

export function CommissionSettlePageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionSettlePageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'bankCardId': json['bankCardId'] == null ? undefined : json['bankCardId'],
        'bankCardNumber': json['bankCardNumber'] == null ? undefined : json['bankCardNumber'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'bankCardHolderName': json['bankCardHolderName'] == null ? undefined : json['bankCardHolderName'],
        'bankCardType': json['bankCardType'] == null ? undefined : json['bankCardType'],
        'months': json['months'] == null ? undefined : ((json['months'] as Array<any>).map(MonthSettleVoFromJSON)),
    };
}

export function CommissionSettlePageItemVoToJSON(json: any): CommissionSettlePageItemVo {
    return CommissionSettlePageItemVoToJSONTyped(json, false);
}

export function CommissionSettlePageItemVoToJSONTyped(value?: CommissionSettlePageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'mobileNo': value['mobileNo'],
        'bankCardId': value['bankCardId'],
        'bankCardNumber': value['bankCardNumber'],
        'bankName': value['bankName'],
        'bankCardHolderName': value['bankCardHolderName'],
        'bankCardType': value['bankCardType'],
        'months': value['months'] == null ? undefined : ((value['months'] as Array<any>).map(MonthSettleVoToJSON)),
    };
}

